__turbopack_context__.v({
  "learnMore": "bH0y1G_learnMore",
  "newsletterBanner": "bH0y1G_newsletterBanner",
  "newsletterBannerSection": "bH0y1G_newsletterBannerSection",
});
